import React, { useCallback } from 'react'
import { IconButton as IconButtonMui, styled } from '@mui/material'
import { MenuIcon } from '$common/icons/menu'
import { showContextMenu } from '$comp/modals/menus/context-menu'

const StyledIconButton = styled(IconButtonMui)`
  padding: 4px;
  position: absolute;
  /* @noflip */
  left: 1px;
  top: 10px;
`

export function MessageMenuIcon({
  roomId,
  iid,
  IconButton = StyledIconButton,
}: {
  roomId: string
  iid: number
  IconButton?: React.ElementType
}) {
  const openContextMenu = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (!(roomId && iid)) return
      showContextMenu({
        roomId,
        iid,
        xAxis: e.clientX,
        yAxis: e.clientY,
      })
    },
    [roomId, iid],
  )

  return (
    <IconButton onClick={openContextMenu}>
      <MenuIcon sx={{ color: '#a7a7a7', width: '20px', height: '20px' }} />
      {/* TODO: get from theme */}
    </IconButton>
  )
}
